// The composer toolbar's emoji button (toolbar order: attach · B I S code · EMOJI · priority · send).
// Opens the picker above the box; the Composer itself inserts the pick at the caret through its
// own place() path, so the box stays the one authority over its text.
import { useState } from 'react';
import { Icon } from '../../../design/icons';
import { t } from '../../../i18n/i18n';
import { EmojiPicker, type AnchorRect } from './EmojiPicker';

export function ComposerEmojiButton({ onPick, onClosed }: { onPick(name: string, custom: boolean): void; onClosed?(): void }) {
  const [open, setOpen] = useState<{ anchor: AnchorRect; startedAt: number } | null>(null);
  return (
    <>
      <button
        type="button"
        className="icon-button"
        data-emoji-opener=""
        title={t('web.emoji.insert')}
        aria-label={t('web.emoji.insert')}
        aria-haspopup="dialog"
        aria-expanded={!!open}
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => {
          const startedAt = performance.now();
          // Above the whole box, not just the button: the picker must never cover the caret.
          const button = e.currentTarget.getBoundingClientRect();
          const box = e.currentTarget.closest('.composer')?.getBoundingClientRect() ?? button;
          const anchor = { left: button.left, right: button.right, top: box.top, bottom: button.bottom };
          setOpen((o) => (o ? null : { anchor, startedAt }));
        }}
      >
        <Icon name="smile" size={16} />
      </button>
      {open ? (
        <EmojiPicker
          anchor={open.anchor}
          startedAt={open.startedAt}
          prefer="above"
          title={t('web.emoji.insert')}
          onPick={(name, custom) => {
            setOpen(null);
            onPick(name, custom);
          }}
          onClose={() => {
            setOpen(null);
            onClosed?.();
          }}
        />
      ) : null}
    </>
  );
}
